import { render, staticRenderFns } from "./BullQuarantine.vue?vue&type=template&id=d7aa6f4e&scoped=true&"
import script from "./BullQuarantine.vue?vue&type=script&lang=js&"
export * from "./BullQuarantine.vue?vue&type=script&lang=js&"
import style0 from "./BullQuarantine.vue?vue&type=style&index=0&id=d7aa6f4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7aa6f4e",
  null
  
)

export default component.exports